import { render, staticRenderFns } from "./BMI.vue?vue&type=template&id=4bf864ad&scoped=true"
import script from "./BMI.vue?vue&type=script&lang=js"
export * from "./BMI.vue?vue&type=script&lang=js"
import style0 from "./BMI.vue?vue&type=style&index=0&id=4bf864ad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bf864ad",
  null
  
)

export default component.exports